import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFormData, updateFormData } from "../../redux-store/formDataSlice";

const bg = `${EASYCOMMERCE.assets}admin/img/icons/bg.png`;
const uploadIcon = `${EASYCOMMERCE.assets}admin/img/icons/upload-icon.png`;

const Brand = () => {
    const dispatch      = useDispatch();
    const formData      = useSelector((state) => state.formData);
    const businessTypes = EASYCOMMERCE.business_type;
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        dispatch(updateFormData({ key: name, value }));
    };
    const openMediaLibrary = () => {
        const frame = wp.media({
            title: "Select Image",
            button: {
                text: "Use selected Image",
            },
            multiple: false,
        });

        frame.on("open", () => {
            const selection = frame.state().get("selection");
            const attachment = wp.media.attachment(formData.logo?.id);
            attachment.fetch();
            selection.add(attachment);
        });

        frame.on("select", () => {
            const attachments = frame.state().get("selection").toJSON();
            const selectedImage = attachments.map(
                (attachment) => attachment.url
            );

            dispatch(updateFormData({ key: "logo", value: selectedImage[0] }));
        });

        frame.open();
    };

    useEffect(() => {
            fetch(`${EASYCOMMERCE.rest_base}/connectivity/setup/get`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "X-WP-Nonce": EASYCOMMERCE.nonce,
                },
            })
                .then((res) => res.json())
                .then((data) => {
                    if (data.success && data?.data?.data) {
                        dispatch(setFormData(data.data.data));
                    }
                });
        }, []);
        

    return (
        <div
            className="bg-cover bg-center w-full flex flex-col items-center"
            style={{
                backgroundImage: `url(${bg})`,
                backgroundSize: "1100px 600px",
                backgroundRepeat: "no-repeat",
            }}
        >
            <div className=" w-[40%] bg-[#FFFFFF] flex flex-col p-10 border-2 border-[#E0E8FF] rounded-xl">
                <div className="flex flex-col w-full space-y-6">
                    <div className="flex flex-col space-y-2">
                        <label
                            className="text-ec-body text-[16px] font-medium"
                            htmlFor="store_name"
                        >
                            Store Name
                        </label>
                        <input
                            id="store_name"
                            type="text"
                            name="store_name"
                            className="easycommerce-wizard-input w-full"
                            placeholder="Write your store name"
                            value={formData.store_name}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div className="flex flex-col space-y-2">
                        <label className="text-ec-body text-[16px] font-medium">
                            Business Type
                        </label>
                        <select
                            id="business_type"
                            name="business_type"
                            className="easycommerce-wizard-input w-full"
                            value={formData.business_type}
                            onChange={handleInputChange}
                        >
                            {Object.entries(businessTypes).map(([value, label]) => (
                                <option key={value} value={value}>
                                    {label}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="flex flex-col space-y-2">
                        <label className="text-ec-body text-[16px] font-medium">
                            Logo
                        </label>
                        <div
                            className="flex flex-col items-center border border-ec-border 
                            border-dashed rounded p-6"
                        >
                            {formData.logo ? (
                                <img
                                    src={formData.logo}
                                    alt="logo"
                                    onClick={openMediaLibrary}
                                    className="max-h-40 object-fill cursor-pointer hover:opacity-70"
                                />
                            ) : (
                                <>
                                    <img src={uploadIcon} alt="logo" />
                                    <p className="text-ec-placeholder text-[16px] leading-[26px] mt-1 mb-4">
                                        Click to upload your store logo
                                    </p>
                                    <button
                                        onClick={openMediaLibrary}
                                        className="flex justify-center items-center gap-[8px] font-inter bg-white group border 
                                        border-ec-primary py-[11px] px-4 rounded-lg text-ec-primary hover:text-white 
                                        hover:bg-ec-primary focus:shadow-none focus:text-white focus:bg-ec-secondary lg:text-sm 
                                        md:text-xs sm:text-sm transition-all ease-in-out duration-500"
                                    >
                                        Upload Logo
                                    </button>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Brand;
